const CollectionPlaceholder = ({ isSearch, gridSize }) => {
    return (
        <div className="collection-placeholder-outer">
            <div className="collection-placeholder-inner">
                <div className="collection-placeholder-filters mb-8">
                    <span className="title-skeleton animate-pulse block h-[30px] bg-stone-100 w-full"></span>
                </div>
                <ul
                    className={`collection-list list-none nostyle w-full grid grid-cols-2 lg:grid-cols-3 ${
                        gridSize && gridSize === 'large'
                            ? 'xl:grid-cols-3'
                            : 'xl:grid-cols-4'
                    } gap-1 relative`}
                >
                    {Array.apply(null, { length: 70 }).map((e, i) => (
                        <li
                            key={i}
                            className="v-placeholder mb-4 lg:mb-6 min-h-[350px] lg:min-h-[500px]"
                        >
                            <span
                                className={`w-full min-h-[150px] animate-pulse bg-stone-100 block mb-2 aspect-[2/3] ${
                                    isSearch
                                        ? 'lg:min-h-[232px]'
                                        : 'lg:min-h-[232px]'
                                }`}
                            ></span>
                            <span className="mt-2 title-skeleton animate-pulse block h-6 bg-stone-100 w-full"></span>
                            <span className="mt-2 title-skeleton animate-pulse block h-4 bg-stone-100 w-2/3"></span>
                            <span className="mt-2 title-skeleton animate-pulse block h-4 bg-stone-100 w-2/3"></span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default CollectionPlaceholder
